import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AppProvider} from "./app.context";
import {IntegratorProvider} from "./integrator.context";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
      <IntegratorProvider>
          <AppProvider>
              <App />
          </AppProvider>
      </IntegratorProvider>
  </React.StrictMode>
);

reportWebVitals();
